interface PaginationProps {
  current: number;
  total: number;
  onChange: (page: number) => void;
}

export default function Pagination({ current, total, onChange }: PaginationProps) {
  if (total <= 1) return null;
  const pages = Array.from({ length: total }, (_, i) => i + 1).filter(
    (p) => p === 1 || p === total || Math.abs(p - current) <= 1,
  );

  return (
    <nav className="mt-8 flex items-center justify-center gap-2" aria-label="分页导航">
      <button
        type="button"
        disabled={current === 1}
        onClick={() => onChange(current - 1)}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors hover:bg-secondary-100 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>
      {pages.map((page, index) => {
        const prev = pages[index - 1];
        const showEllipsis = prev && page - prev > 1;
        return (
          <span key={page} className="flex items-center gap-2">
            {showEllipsis && <span className="px-1 text-foreground-400">…</span>}
            <button
              type="button"
              onClick={() => onChange(page)}
              className={`h-9 min-w-9 rounded-md px-3 text-sm font-medium transition-colors ${
                page === current
                  ? "bg-primary-500 text-background-50"
                  : "border border-background-300 text-foreground-700 hover:bg-secondary-100"
              }`}
            >
              {page}
            </button>
          </span>
        );
      })}
      <button
        type="button"
        disabled={current === total}
        onClick={() => onChange(current + 1)}
        className="flex h-9 w-9 items-center justify-center rounded-md border border-background-300 text-foreground-600 transition-colors hover:bg-secondary-100 disabled:cursor-not-allowed disabled:opacity-40"
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}